import React from 'react';
import PropTypes from 'prop-types';
Auth.propTypes = {
    children: PropTypes.object
};
export default function Auth(_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b;
    return (React.createElement("div", { className: "wrapper wrapper--alternate wrapper--main-bg" },
        React.createElement("div", { className: "container-fluid" }, children)));
}
